import { Box, ColorOptions, Icon, ModBox, SpacerNew, Text } from '@jfs/ui-new'
import { getRandomAlphaNumString, isEmpty } from '@jfs/utils'
import { FlatList } from 'react-native'
import { campaignDetailKeys, Colors } from '../../util/util'
import { TextWithCopy } from './TextWithCopy'

const ListItem = ({ title, subTitle, showCopyIcon = false }: any) => {
  if (!subTitle || isEmpty(subTitle)) {
    return null
  }
  return (
    <Box pt={8} pb={16} pr={16} w={300}>
      <Text
        title={campaignDetailKeys[title] ?? title}
        color={Colors.HELPER_TEXT as ColorOptions}
        fontSize={12}
        fontFamily={'jiotype-medium'}
      />
      <SpacerNew size={8} direction={'vertical'} />
      <TextWithCopy text={subTitle} showCopyIcon={showCopyIcon} />
    </Box>
  )
}

const RenderProductValues = ({ data }: any) => {
  const subTitle = (val) => {
    return val.join(', ')
  }
  return (
    <Box>
      {data?.map((item: any) => {
        if (item?.value?.length === 0) {
          return null
        }
        return (
          <Text fontSize={14} fontFamily={'jiotype-medium'} lineHeight={21} key={getRandomAlphaNumString(3)}>
            {`${item.key} : `}
            <Text title={subTitle(item.value)} color={'BLUE'} fontFamily={'jiotype-medium'} fontSize={14} />
          </Text>
        )
      })}
    </Box>
  )
}
const ProductListItem = ({ title, data, showCopyIcon = false }) => {
  if (data?.length === 0) {
    return null
  }
  const subTitle = data.reduce((result, category) => {
    result = result + `${category?.key}` + ' : '
    const formattedValues = category?.value.join(',')
    result = result + formattedValues
    return result
  }, '')
  return (
    <Box flexWrap={'wrap'} pt={8} pb={16} pr={32} w={300} nativeID={'list-wrapper'}>
      <Text
        title={campaignDetailKeys[title] ?? title}
        color={Colors.HELPER_TEXT as ColorOptions}
        fontSize={12}
        fontFamily={'jiotype-medium'}
      />
      <SpacerNew size={8} direction={'vertical'} />
      <TextWithCopy text={subTitle} TextComp={<RenderProductValues data={data} />} showCopyIcon={showCopyIcon} />
    </Box>
  )
}

export const Rules = ({ data }: any) => {
  const keys = Object.keys(data?.[0] ?? {})
  const productKeys = Object.keys(data?.[1]?.products ?? {})
  const productData = Object.values(data?.[1]?.products ?? {})
  const renderItem = ({ item }: any) => {
    return (
      <Box nativeID={'mid-selector'}>
        <ListItem title={item} subTitle={data?.[0]?.[item]} showCopyIcon={item === 'bin'} />
      </Box>
    )
  }

  const renderProdItem = ({ item, index }: any) => {
    if (index === 0) {
      return <ListItem title={'Transaction/event type'} subTitle={'Product purchase'} />
    }

    return (
      <Box nativeID="mid-selector">
        <ProductListItem
          title={item}
          data={productData[index]}
          showCopyIcon={['applicableProducts', 'notApplicableProducts'].includes(item)}
        />
      </Box>
    )
  }
  console.log('keys keyskeyskeys', keys)
  return (
    <>
      <Box flexDirection={'row'} align={'center'}>
        <Box h={32} w={32} borderRadius={16} borderWidth={1} borderColor={'BLUE'} align={'center'} justify={'center'}>
          <Box bg={'#E2F1F6' as ColorOptions} w={24} h={24} borderRadius={12} align={'center'} justify={'center'}>
            <Icon color={'BLUE'} size={16} id={'INFO'} />
          </Box>
        </Box>
        <SpacerNew direction="horizontal" size={10} />
        <Text title={'Rules Configuration'} fontSize={14} fontFamily={'jiotype-bold'} />
      </Box>
      <Box borderLeftWidth={2} borderLeftColor={'BLUE'} marginLeft={16} marginVertical={8} pl={26}>
        <FlatList data={keys} renderItem={renderItem} numColumns={3} />
        <ModBox
          show={data?.length === 2 && productKeys?.length > 0 && productData?.length > 0}
          borderTopWidth={0.5}
          borderTopStyle={'dashed'}
          alignItems={'center'}
          mt={45}
          mb={26}
          w={900}>
          <Box
            position={'absolute'}
            top={-13}
            borderWidth={1}
            borderColor={'#9B9B9B' as ColorOptions}
            align={'center'}
            justify={'center'}
            h={26}
            bg={'WHITE'}
            borderRadius={13}
            ph={20}>
            <Text title={'Rule 02'} fontFamily={'jiotype-medium'} fontSize={12} color={'#9B9B9B' as ColorOptions} />
          </Box>
        </ModBox>
        <ModBox
          show={data?.length === 2 && productKeys?.length > 0 && productData?.length > 0}
          flexDirection={'row'}
          flexWrap={'wrap'}>
          <FlatList data={productKeys} renderItem={renderProdItem} numColumns={3} />
        </ModBox>
      </Box>
    </>
  )
}
